import { render, staticRenderFns } from "./ProgramAwardSetupTab.vue?vue&type=template&id=2a69064a&scoped=true&"
import script from "./ProgramAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProgramAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProgramAwardSetupTab.vue?vue&type=style&index=0&id=2a69064a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69064a",
  null
  
)

export default component.exports